import React from "react";
import { Box, Typography, Grid } from "@mui/material";

const apiUrl = process.env.REACT_APP_API_URL;

const categories = [
  {
    img: `${apiUrl}/static/media/sofa.jpg`,
    title: "Sohvat ja nojatuolit",
    link:'Sohvat'
  },
  {
    img: `${apiUrl}/static/media/bed.jpg`,
    title: "Sängyt ja patjat",
    link:'Sängyt'
  },
  {
    img: `${apiUrl}/static/media/furniture.jpg`,
    title: "Uudet Huonekalut",
    link:'Uudet Huonekalut'
  },
  {
    img: `${apiUrl}/static/media/matot.jpg`,
    title: "Matot",
    link:'Matot'
  },
  {
    img: `${apiUrl}/static/media/muut.jpg`,
    title: "Muut",
    link:'Muut'
  },
];

function Categories() {

  const handleclick= (key) => {
    if (key !==''){
      localStorage.setItem('filter',key)
    }
  };

  return (
    <Box flexGrow={1} width={{ lg: '80%', md: '90%', sm: '100%' }} ml={{ md: '5%', lg: '10%' }} mt={{xs:'3vh', md:'8vh'}}>
        {//<Typography variant="h4" color="error" mb={5}> Kategories </Typography>
        }
      <Grid container spacing={3} justifyContent="center">
        {categories.map((category, index) => (
          <Grid
            item
            key={index}
            xs={6} // Küçük ekranlarda iki öğe
            sm={4} // Orta ekranlarda üç öğe
            md={3} // Büyük ekranlarda dört öğe
            lg={2} // Daha büyük ekranlarda altı öğe
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              
            }}
          >
            <Box
              component='a' 
              href="/products"
              onClick={() => handleclick(category.link)}
              sx={{
                width: 150,
                height: 150,
                borderRadius: "50%",
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: 'white',
                "&:hover": {
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                },
              }}
            >
              <img
                loading='lazy'
                src={category.img}
                alt={'Käytetty ' + category.title}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
            <Typography variant='h5'
            component='a' 
            href="/products"
            color='#37474f'
            onClick={() => handleclick(category.link)}
            sx={{ mt: 1 ,
              textDecoration:'none',
              "&:hover": {
                textDecoration: 'underline', 
                color:'black'
              },
            }}
            >
              {category.title}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default Categories;
